var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-row',{attrs:{"showElement":_vm.showElement,"label":_vm.label,"elId":_vm.elId,"status":_vm.status,"config":_vm.config,"me":_vm.me}},[_c('b-form-input',{attrs:{"id":_vm.elId,"type":"text","value":_vm.myValue,"readonly":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }